exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".height-dash {\r\n  height: calc(100vh - 50px) !important;\r\n  /* overflow-y: auto; */\r\n}\r\napp-navbar {\r\n  height: 50px !important;\r\n}\r\n.open {\r\n  /* background-color: red !important; */\r\n  display: none;\r\n  transition: 3s ease-in-out;\r\n}\r\n.th-100 {\r\n  height: 100%;\r\n}\r\n@media (max-width: 576px) {\r\n  .sidebar-nav {\r\n    width: 100% !important;\r\n    z-index: 10;\r\n    position: fixed;\r\n    /* height: 100vh; */\r\n\r\n    /* background-color: #2c3e50 !important; */\r\n  }\r\n}\r\n/*.bg-dash {*/\r\n/*  background-color: #e9e9e9;*/\r\n/*}*/\r\n\r\n\r\n.side-nav-item {\r\n  padding: 1rem;\r\n}\r\n.side-nav-item:hover {\r\n  cursor: pointer;\r\n  background-color: #E5E3F2;\r\n  color: #3e5771;\r\n}\r\n\r\n\r\n.active {\r\n  background-color: #3e5771;\r\n  color: #e7e7e8;\r\n}\r\n\r\n\r\n.students {\r\n  display: none; /* Hide by default */\r\n}\r\n\r\n@media (max-width: 769px) {\r\n  .students {\r\n    display: block; /* Show only when screen width is 769px or less */\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/dashboard.component.css
// module id = ../../../../../src/app/parent/dashboard/dashboard.component.css
// module chunks = main